import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import { Grid } from '@mui/material'
import { usePOST_assessPeerSubmissionMutation } from 'redux/api/peerAssessmentsApi'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import RichTextField from 'components/atoms/fields/RichTextField'
import InputField from 'components/atoms/fields/InputField'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { initialValues, validationSchema } from 'utils/formModels/peerAssessmentModel'


interface IProps {
  submission: any
}

const PeerAssessmentForm: FC<IProps> = ({ submission }) => {

  const { t } = useTranslation()

  const {
    grade_comment,
    grade_percentage,
    status
  } = formModel()

  const [
      assessStudent,
      { isLoading: assessLoading, isSuccess: assessSuccess, error: assessError, data: assesseData },
  ] = usePOST_assessPeerSubmissionMutation()
  useErrorAlert(assessError)
  useSuccessAlert(assessSuccess ? `${t('alerts.entity-saved', {entity: 'Assess data'})}` : '')


  const serverValues = submission.peer_assessment ? {
    grade_comment: submission.peer_assessment.grade_comment,
    grade_percentage: submission.peer_assessment.grade_percentage,
  } : null

  const isPublished = submission.peer_assessment?.status === 'published'

  return (
      <Formik
        enableReinitialize
        initialValues={serverValues || initialValues}
        validationSchema={validationSchema}
        onSubmit={(values: any) => { 

          assessStudent({ id: submission.id, body: {...values, status: 'published'}})
        }}>
          {({ values }) => {
            return (
              <Form>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={9}>
                    <RichTextField
                      width={'100%'}
                      height={'150px'}
                      fieldProps={{...grade_comment}}
                      label={grade_comment.label}
                      disabled={isPublished}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                      <InputField
                          fieldProps={{...grade_percentage}}
                          sx={{ width: '150px', marginTop: '20px' }}
                          disabled={isPublished}
                      />
                      {!isPublished &&
                      <SubmitButton
                        color={'success'}
                        text={`${t('common.save-assessment')}`}
                        sx={{ width: '150px', marginTop: '20px' }}
                        isLoading={assessLoading}
                        alignRight={false}
                      />
                      }
                  </Grid>
                </Grid>
              </Form>
            )
          }}
      </Formik>
  )
}

export default PeerAssessmentForm
